export function useSiteConfig() {
  const config = import.meta.env.VITE_SITE_CONFIG || {
    siteName: 'VentScape',
    siteId: 'ventscape',
    title: 'VentScape - Chat & vent anonymously with others online',
    shortTitle: 'VentScape - Chill Anonymous Chat Rooms',
    subtitle: 'A chill anonymous chat room to chat, vent, and connect',
    description: 'Free anonymous chat rooms. Chat and vent anonymously with others online.',
    canonicalUrl: 'https://ventscape.com/',
    ogImage: 'https://ventscape-assets.s3.amazonaws.com/og+image.png',
    theme: {
      primaryColor: '#000000',
      backgroundColor: '#ffffff'
    }
  };
  
  return config;
}

export function getSiteName() {
  return import.meta.env.VITE_SITE_NAME || 'VentScape';
}

export function getSiteSubtitle() {
  const config = useSiteConfig();
  return config.subtitle || 'A chill anonymous chat room to chat, vent, and connect';
}

export function isChatScapeMode() {
  const siteName = getSiteName();
  return siteName.toLowerCase().includes('chatscape');
}